<div class="provider-dashboard">

  <!-- ── Hero / profile strip ── -->
  <div class="profile-hero">
    <div class="profile-avatar">{{ providerInitials }}</div>
    <div class="profile-info">
      <div class="profile-name">{{ provider?.firstName }} {{ provider?.lastName }}</div>
      <div class="profile-trade">{{ tradeLabel }}</div>
      <div class="profile-meta">
        <span *ngIf="serviceAreaDisplay !== '—'">
          <mat-icon class="meta-icon">location_on</mat-icon> {{ serviceAreaDisplay }}
        </span>
        <span *ngIf="provider?.email">
          <mat-icon class="meta-icon">email</mat-icon> {{ provider?.email }}
        </span>
        <span *ngIf="provider?.phone">
          <mat-icon class="meta-icon">phone</mat-icon> {{ provider?.phone }}
        </span>
      </div>
    </div>
    <div class="profile-actions">
      <button mat-raised-button color="primary" (click)="goToManageServices()">
        <mat-icon>add_circle</mat-icon> Manage Services
      </button>
    </div>
  </div>

  <!-- ── Stats row ── -->
  <div class="stats-row">
    <div class="stat-card">
      <mat-icon class="stat-icon">home_repair_service</mat-icon>
      <div class="stat-value">{{ services.length }}</div>
      <div class="stat-label">Active Services</div>
    </div>
    <div class="stat-card">
      <mat-icon class="stat-icon">event_available</mat-icon>
      <div class="stat-value">{{ bookings.length }}</div>
      <div class="stat-label">Bookings</div>
    </div>
    <div class="stat-card">
      <mat-icon class="stat-icon">star</mat-icon>
      <div class="stat-value">{{ provider?.rating ?? '—' }}</div>
      <div class="stat-label">Rating</div>
    </div>
  </div>

  <!-- ── My Services ── -->
  <div class="section-card">
    <div class="section-header">
      <h2 class="section-title">
        <mat-icon>home_repair_service</mat-icon> My Services
      </h2>
      <button mat-stroked-button (click)="goToManageServices()">
        <mat-icon>edit</mat-icon> Edit
      </button>
    </div>

    <div *ngIf="isLoadingServices" class="loading-state">
      <div class="css-spinner"></div>
      <span>Loading services…</span>
    </div>

    <div *ngIf="!isLoadingServices && services.length === 0" class="empty-state">
      <mat-icon>home_repair_service</mat-icon>
      <p>No services yet. Add your first service so customers can find you.</p>
      <button mat-raised-button color="primary" (click)="goToManageServices()">
        <mat-icon>add</mat-icon> Add Service
      </button>
    </div>

    <div class="services-grid" *ngIf="!isLoadingServices && services.length > 0">
      <div class="service-card" *ngFor="let svc of services">
        <div class="service-category">{{ svc.category }}</div>
        <div class="service-title">{{ svc.title }}</div>
        <div class="service-desc">{{ svc.description }}</div>
        <div class="service-footer">
          <span class="service-price">{{ svc.price | currency }}</span>
          <span class="service-duration">{{ svc.duration }} min</span>
          <span class="service-recurring" *ngIf="svc.isRecurring">Recurring</span>
        </div>
        <div class="service-area" *ngIf="svc.serviceArea?.length">
          <mat-icon class="meta-icon">location_on</mat-icon>
          {{ svc.serviceArea.join(', ') }}
        </div>
      </div>
    </div>
  </div>

  <!-- ── Bookings ── -->
  <div class="section-card">
    <div class="section-header">
      <h2 class="section-title">
        <mat-icon>event_available</mat-icon> Bookings
      </h2>
    </div>

    <div *ngIf="isLoadingBookings" class="loading-state">
      <div class="css-spinner"></div>
      <span>Loading bookings…</span>
    </div>

    <div *ngIf="!isLoadingBookings && bookings.length === 0" class="empty-state">
      <mat-icon>calendar_today</mat-icon>
      <p>No bookings yet. Once customers book your services they'll appear here.</p>
    </div>

    <p class="invoice-error" *ngIf="invoiceError">{{ invoiceError }}</p>

    <table class="table table-striped table-sm" *ngIf="!isLoadingBookings && bookings.length > 0">
      <thead>
        <tr>
          <th>Service</th>
          <th>Date</th>
          <th>Status</th>
          <th>Price</th>
          <th>Invoice</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let b of bookings">
          <td>{{ b.serviceName }}</td>
          <td>{{ b.scheduledDate }} {{ b.scheduledTime }}</td>
          <td><span class="status-badge" [ngClass]="'status-' + b.status">{{ b.status }}</span></td>
          <td>{{ b.price | currency }}</td>
          <td>
            <span *ngIf="b.stripeInvoiceId" class="status-badge status-completed">{{ b.invoiceStatus || 'sent' }}</span>
            <button mat-stroked-button *ngIf="canInvoice(b)" [disabled]="invoicingBookingId === b.id"
                    (click)="sendInvoice(b)" title="Send a Stripe invoice for this booking">
              {{ invoicingBookingId === b.id ? 'Sending…' : 'Send Invoice' }}
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

</div>
